import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import FeaturedProductsByCategory from "../components/featuredproductsbycat"
import FeaturedProductsHomepage from "../components/featuredproductshomepage"
import { FilterProductsByShowOnHomepage } from "../helpers/product-filter";
import img1 from "../images/products/elephanthamper/elephant1.jpeg"
import brownsafarimain from '../images/products/brownsafari/brownsafarimain.png'
import bluemuslinmain from '../images/products/bluemuslin/bluemuslinmain.png'
import pinkfloralemain from "../images/products/pinkfloral/pinkfloralmain.png"
import newbabyletterboxmain from '../images/products/newbabyletterbox/newbabyletterboxmain.png'
import sheepbathmain from '../images/products/sheepbath/sheepbathmain.png'
import greyelephant from '../images/products/greyelephant.jpeg'
import sheepblanket from '../images/products/sheepblanket.jpeg'
import waffles from '../images/products/waffles.jpeg'
import hats2 from '../images/products/hats2.jpeg'
import sheepgown from '../images/products/sheepgown.jpeg'
import bluemuslinrompermain from '../images/products/bluemuslinromper/bluemuslinrompermain.jpeg'
import thpcsheepmain from '../images/products/thpcsheep/thpcsheepmain.jpeg'
import boyhamper from '../images/products/boyhamper.jpeg'
import unisexhamper from '../images/products/unisexhamper.jpeg'
import comfortershome from '../images/products/comfortershome.jpeg'
import babyaccessories from '../images/products/babyaccessories.jpeg'
import greystar from '../images/products/greystar.jpeg'
import winterwarmer from '../images/products/winterwarmer.jpeg'
import ecohome from '../images/products/ecohome.jpeg'
import girlshome from '../images/products/girlshome.jpeg'
import cosyhome from '../images/products/cosyhome.jpeg'
import christmashome from '../images/products/christmashome.jpeg'
import starelephanthamper from '../images/products/starelephanthamper.jpeg'
import salehome from '../images/products/salehome.jpeg'
import pinkbearsuitcase from '../images/products/pinkbearsuitcase.jpeg'
import fiverfriday from '../images/products/fiverfriday.jpeg'
import twopackfloralonesies from '../images/products/lemonfloral/twopackfloralonesies.jpeg'
import quiltedsheepmain from "../images/products/quiltedsheep/quiltedsheepmain.jpeg"
import whitegiraffehamper from '../images/products/whitegiraffehamper.jpeg'
import fipcelephantstar from '../images/products/fipcelephantstar.jpeg'
import fipcneutralhelloworldmain from '../images/products/fipcneutralhelloworld/fipcneutralhelloworldmain.jpeg'
import peachtropicalromper from '../images/products/peachtropicalromper.jpeg'
import babyannouncevestmain from '../images/products/personalisedvests/babyannouncevestmain.jpeg'

const IndexPage = () => {


	const welcome = <div className="homepageBlurb">
		<h2>We have something for every little one.</h2>
		<p>Welcome a new baby into the world with one of our beautiful hampers or baby gifts. All of our hampers are designed by us here in the UK and each order is packed individually with love and care.  
			<br /><br/>Each of our hampers and gifts are perfect for pregnancy anouncements, baby shower presents, newborn baby gifts or to congratulate the new parents on their new arrival. 
			<br /><br/> With a great selection of Clothing, Onesie Sets, Toys, Keepsakes and many more items, we're here to help you find that perfect gift.</p>
	</div>;

	const section1 = <div className="homepageBlurb">
		<h2>Baby Hampers</h2>
	</div>;

	const section2 = <div className="homepageBlurb">
		<h2>Section 2</h2>
		<p></p>
	</div>;

	const section3 = <div className="homepageBlurb">
		<h2>Section 3</h2>
		<p></p>
		</div>;

	const cats = [
		{ name: "Personalised Gifts", link: '/personalised-clothing', img: babyannouncevestmain  },
		{ name: "Unisex Hampers", link: '/unisex', img: fipcneutralhelloworldmain},
		{ name: "Baby Boy Hampers", link: '/boys', img: boyhamper },
		{ name: "Baby Girl Hampers", link: '/girls', img: girlshome  },
		{ name: "Cosy Hampers", link: '/cosy-hampers', img: cosyhome  },
		{ name: "Eco Friendly Hampers", link: '/eco-hampers', img: ecohome  }
	];

	const gifts = [
		{ name: "Comforters", link: '/comforters', img: comfortershome  },
		{ name: "Spring/Summer", link: '/spring-summer', img: peachtropicalromper},
		{ name: "Baby Accessories", link: '/baby-accessories', img: babyaccessories  },
		{ name: "Bathtime Accessories", link: '/bathtime-accessories', img: sheepgown  },
		{ name: "Clothing", link: '/clothing', img: quiltedsheepmain},
		{ name: "Onesie Sets", link: '/onesie-sets', img: fipcelephantstar}
	];

	const personalised = [
		{ name: "Personalised Hampers", link: '/personalised-hampers', img: img1  },
		{ name: "Personalised Blankets", link: '/personalised-blankets', img: img1 },
		{ name: "Personalised Comforters", link: '/personalised-comforters', img: img1  },
		{ name: "Personalised Clothing", link: '/personalised-clothing', img: img1  },
	];

	return (
		<Layout>
			<SEO title="Home" />
			{welcome}
			
			<FeaturedProductsByCategory parentName={"Baby Hampers"} cats={cats} />

			<FeaturedProductsByCategory parentName={"Gifts and Accessories"} cats={gifts} />

			<FeaturedProductsHomepage name={"Best Sellers"} products={FilterProductsByShowOnHomepage("best-sellers").slice(0, 4)}/>

		</Layout>
	)
}

export default IndexPage
